import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import PaymentOrdersEditTab from './Elements/PaymentOrdersEditTab';
import PaymentOrdersTrainingTab from './Elements/PaymentOrdersTrainingTab';
import PaymentOrdersScheduleTab from './Elements/PaymentOrdersScheduleTab';
import PaymentOrdersRestitutionTab from './Elements/PaymentOrdersRestitutionTab';
import getLocale from '../../i18n/getLocale';

class PaymentOrdersEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      payment_order_data: {},
      errors_listing: false,
      errors_messages: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.refreshNationals = this.refreshNationals.bind(this);
    this.refreshInternationals = this.refreshInternationals.bind(this);
    this.refreshHours = this.refreshHours.bind(this);
    this.refreshTrainingHours = this.refreshTrainingHours.bind(this);
    this.refreshMission = this.refreshMission.bind(this);
    this.refreshDeslocation = this.refreshDeslocation.bind(this);
    this.refreshTransport = this.refreshTransport.bind(this);
    this.refreshChecks = this.refreshChecks.bind(this);
    this.refreshChiefs = this.refreshChiefs.bind(this);
    this.loadData = this.loadData.bind(this);
    this.listErrors = this.listErrors.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  listErrors(responseJson) {
    this.setState({errors_listing: true, errors_messages: responseJson.data, overlay: {message: '', type: '', status: 'closed'}});
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/contratos');
        if (responseJson.status === 'success') {
          self.setState({payment_order_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/treinamento/horas/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_training_hours: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/horas/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_hours: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/diarias/nacionais/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_daily_national: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/diarias/missao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_daily: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/diarias/internacionais/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_daily_international: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/indenizacao/cheque/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_checks: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/indenizacao/representante/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_base_chiefs: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/indenizacao/deslocamento/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_distance: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/indenizacao/transporte/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_transport: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Lista pagamentos horas de treinamento */ }); /* Lista pagamentos horas */ }); /* Lista pagamentos nacionais */}); /* Lista pagamentos nacionais de  missão */}); /* Lista pagamentos internacionais */ }); /* Lista indenizações de cheque */ }); /* Lista indenizações de representante operacional */}); /* Lista indenizações de deslocamento */}); /* Lista indenizações de transporte */ });
  }

  refreshInternationals (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/diarias/internacionais/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_daily_international: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Overlay */
  }

  refreshNationals (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/diarias/nacionais/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_daily_national: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Overlay */
  }

  refreshMission (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/diarias/missao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_daily: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Overlay */
  }

  refreshTrainingHours (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/treinamento/horas/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_training_hours: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Overlay */
  }

  refreshHours (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/horas/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_hours: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Overlay */
  }

  refreshChecks (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/indenizacao/cheque/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_checks: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Overlay */
  }

  refreshChiefs (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/indenizacao/representante/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_base_chiefs: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Overlay */
  }

  refreshDeslocation (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/indenizacao/deslocamento/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_distance: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Overlay */
  }

  refreshTransport (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordem/pagamento/pagamentos/indenizacao/transporte/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_order_payments_transport: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Overlay */
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.OrdensDePagamento.EditarOrdemDePagamento.titulo}</h3>
      <Link to={this.state.payment_order_data.status === "enviado" ? "/ordens/pagamentos/enviadas" : "/ordens/pagamentos/abertas"} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Os seguintes erros impediram o pagamento de ser enviado:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabDadosDaOrdemDePagamento.tituloTab}>
          <PaymentOrdersEditTab handleAlert={this.handleAlert} payment_order_id={this.props.match.params.id} payment_order_data={this.state.payment_order_data} listErrors={this.listErrors} />
        </Tab>
        {this.state.payment_order_data.type === 'Treinamentos' &&
          <Tab eventKey={2} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tituloTab}>
            <PaymentOrdersTrainingTab RequestApi={this.refs.request_api} refreshHours={this.refreshTrainingHours} refreshNationals={this.refreshNationals} refreshInternationals={this.refreshInternationals}  handleAlert={this.handleAlert} payment_order_id={this.props.match.params.id} payment_order_payments_hours={this.state.payment_order_payments_training_hours} payment_order_payments_daily_national={this.state.payment_order_payments_daily_national} payment_order_payments_daily_international={this.state.payment_order_payments_daily_international} payment_order_data={this.state.payment_order_data} />
          </Tab>
        }
        {this.state.payment_order_data.type === 'Missão' &&
          <Tab eventKey={3} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tituloTab}>
            <PaymentOrdersScheduleTab RequestApi={this.refs.request_api} refreshHours={this.refreshHours} refreshMission={this.refreshMission} refreshInternationals={this.refreshInternationals}  handleAlert={this.handleAlert} payment_order_id={this.props.match.params.id} payment_order_payments_hours={this.state.payment_order_payments_hours} payment_order_payments_daily={this.state.payment_order_payments_daily} payment_order_payments_daily_international={this.state.payment_order_payments_daily_international} payment_order_data={this.state.payment_order_data} />
          </Tab>
        }
        <Tab eventKey={4} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabIndenizacoes.tituloTab}>
          <PaymentOrdersRestitutionTab RequestApi={this.refs.request_api} refreshChiefs={this.refreshChiefs} refreshChecks={this.refreshChecks} refreshDeslocation={this.refreshDeslocation} refreshTransport={this.refreshTransport} handleAlert={this.handleAlert} payment_order_id={this.props.match.params.id} payment_order_payments_checks={this.state.payment_order_payments_checks} payment_order_payments_base_chiefs={this.state.payment_order_payments_base_chiefs} payment_order_payments_daily_international={this.state.payment_order_payments_daily_international} payment_order_payments_distance={this.state.payment_order_payments_distance} payment_order_payments_transport={this.state.payment_order_payments_transport} payment_order_data={this.state.payment_order_data} />
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentOrdersEdit;



// WEBPACK FOOTER //
// ./src/Components/PaymentOrders/PaymentOrdersEdit.js